import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "plan-content" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12 col-md-8" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "pdt-10" }, "COBRA elections can only be made by timely submitting the COBRA application to the Fund Office. COBRA coverage elections cannot be made on this website. This screen is available to make VISA or MasterCard payments once your payment invoice has been issued after your election has been received.", -1)
const _hoisted_6 = { class: "cobra-statements mt-30 row row-cols-1 row-cols-md-2" }
const _hoisted_7 = { class: "cobra-statement" }
const _hoisted_8 = { class: "cobra-statement__header" }
const _hoisted_9 = { class: "checkbox alert-checkbox" }
const _hoisted_10 = { class: "checkbox-input" }
const _hoisted_11 = ["checked", "onChange"]
const _hoisted_12 = { class: "cobra-statement__content" }
const _hoisted_13 = { class: "row align-items-center row-cols-1 row-cols-md-2" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "cobra-statement__info" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h6", null, "For Coverage Period:", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { class: "cobra-statement__info" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h6", null, "Due Date:", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "cobra-statement__info" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "But no longer than:"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, /*#__PURE__*/_toDisplayString('N/A'))
  ])
], -1)
const _hoisted_21 = { class: "col d-flex flex-column align-items-center" }
const _hoisted_22 = { class: "cobra-statement__content__amount" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, "Amount Due", -1)
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "cobra-statement__footer" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "col" }
const _hoisted_28 = { class: "cobra-statement" }
const _hoisted_29 = { class: "cobra-statement__header" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h4", null, "Additional Amount", -1)
const _hoisted_31 = { class: "checkbox alert-checkbox" }
const _hoisted_32 = { class: "checkbox-input" }
const _hoisted_33 = ["checked"]
const _hoisted_34 = { class: "cobra-statement__content" }
const _hoisted_35 = { class: "row align-items-center row-cols-1 row-cols-md-2" }
const _hoisted_36 = { class: "text-input" }
const _hoisted_37 = { class: "cobra-statement__footer" }
const _hoisted_38 = { class: "row mt-20" }
const _hoisted_39 = { class: "d-flex w-100 justify-content-center justify-content-md-end mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", null, "Pending COBRA Invoices for " + _toDisplayString($setup.personName), 1),
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            ($setup.cobraStatements.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.cobraStatements, (statement) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "col",
                    key: statement.InvoiceID
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("h4", null, _toDisplayString(statement.PlanName), 1),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              class: "links alert-checkbox",
                              checked: $setup.invoicesStore.isInvoiceSelected(statement.InvoiceID),
                              onChange: ($event: any) => ($setup.invoicesStore.toggleInvoiceSelection(statement.InvoiceID))
                            }, null, 40, _hoisted_11)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                              _hoisted_16,
                              _createElementVNode("p", null, [
                                _createElementVNode("strong", null, _toDisplayString(statement.InsuranceStartDate), 1),
                                _createTextVNode(" to"),
                                _hoisted_17,
                                _createElementVNode("strong", null, _toDisplayString(statement.InsuranceEndDate), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              _hoisted_19,
                              _createElementVNode("p", null, [
                                _createElementVNode("strong", null, _toDisplayString(statement.DueDate), 1)
                              ])
                            ]),
                            _hoisted_20
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _hoisted_23,
                              _createElementVNode("h5", null, _toDisplayString($setup.formatCurrency(statement.Amount)), 1)
                            ]),
                            _createElementVNode("a", {
                              onClick: _withModifiers(($event: any) => ($setup.openModal('smartsearch', null, 'modal-success', null, { DocumentID: statement.DocumentID })), ["prevent"]),
                              class: "btn btn-invoice btn-small mt-20"
                            }, "View Invoice", 8, _hoisted_24)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("button", {
                          class: "btn btn-primary w-100",
                          onClick: ($event: any) => ($setup.invoicesStore.toggleInvoiceSelection(statement.InvoiceID))
                        }, _toDisplayString($setup.invoicesStore.isInvoiceSelected(statement.InvoiceID) ? 'Selected' : 'Select this invoice'), 9, _hoisted_26)
                      ])
                    ])
                  ]))
                }), 128))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        class: "links alert-checkbox",
                        checked: $setup.invoicesStore.payInAdvanceSelected,
                        onChange: _cache[0] || (_cache[0] = ($event: any) => ($setup.invoicesStore.togglePayInAdvance()))
                      }, null, 40, _hoisted_33)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.invoicesStore.payInAdvance) = $event)),
                        placeholder: "Enter Amount"
                      }, null, 512), [
                        [
                          _vModelText,
                          $setup.invoicesStore.payInAdvance,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("button", {
                    class: "btn btn-primary w-100",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($setup.invoicesStore.togglePayInAdvance()), ["prevent"]))
                  }, _toDisplayString($setup.invoicesStore.payInAdvanceSelected ? 'Selected' : 'Select'), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => ($setup.proceedToCheckout && $setup.proceedToCheckout(...args)), ["prevent"])),
                class: "btn btn-primary plan-modal"
              }, " Make COBRA Payment ")
            ])
          ])
        ])
      ])
    ])
  ]))
}